export const adaptTipoAcceso = (TipoAccesoData) => {
    return {
        id: TipoAccesoData?.idTipoAcceso,
        displayName: TipoAccesoData?.nombre,
    }
}

export const adaptTipoAccesoArray = (
    tipoAccesos
) => {
    return structuredClone(tipoAccesos?.allTipoAcceso)
        ?.map(tipoAcceso => adaptTipoAcceso(tipoAcceso));
}